const listeners = new Set();

/** Register a callback invoked whenever the live preview should reload. Returns an unsubscribe function. */
export const subscribePreviewRefresh = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

export const notifyPreviewRefresh = () => {
  listeners.forEach((callback) => {
    try {
      callback();
    } catch (error) {
      console.error('Preview refresh listener failed:', error);
    }
  });
};
